import React from 'react';
import { withRouter } from 'react-router-dom';
import { scrollToTop } from 'Core/Utils/DomUtils';

function LinkBox (props) {
  const { history, to, match, location, staticContext, ...subProps } = props;
  subProps.onClick = () => {
    if (!to) return;
    history.push(to);
    scrollToTop();
  }
  return (<div {...subProps} />);
};

export default withRouter(LinkBox);



// WEBPACK FOOTER //
// ./client/Core/Components/LinkBox.jsx